import React, { useState, useEffect } from "react";
import { Col,  Input, Row,  Card, Select, Form } from "antd";
import { useIntl } from "react-intl";
import { Form_Item } from "./FormItem-component";
import { getCountryListData, getRegionListData } from "../services/SelectServices";
import { getControlRuleset, getDefaultDisabledRuleset,  getDefaultNotRequiredRuleset,  getDefaultRequiredRuleset } from "../RulesEngine";
import { getI18n } from "../../../utils/Utils";
import { FormInstance } from "antd/es/form/Form";
import { useAppDispatch, useAppSelector } from "../../../main/hooks";
import { updateFiscalCountryCode, updateFiscalRegionCode, updateShippingFromCountryCode, updateShippingFromRegionCode, updateShippingToCountryCode, updateShippingToRegionCode } from "../../e-cap/IStoredDocumentRecordSlice";
import { isArray } from "lodash";
import { SupportOptionRange } from "prettier";
import { CompassOutlined } from "@ant-design/icons";
import {RuleResultCache, RuleSet} from "../util/RuleResultCache";


const { Option } = Select;

type addressDetailsProps = {
  form: FormInstance<any>;
  regionDisplayFldName: any;
  regionCodeFldLabel?: string;
  regionCodeFldName: any;
  regionCodeFldRule?: string;
  regionCodePlaceholder?: string;
  streetFldName: any;
  streetFldLabel?: string;
  streetFldRule?: any;
  streetFldPlaceholder?: string;
  countryDisplayFldName: any;
  countryFldLabel?: string
  countryCodeFldName: any;
  countryFldRule?: any;
  countryFldPlaceholder?: string;
  postalCodeFldName: any;
  postalCodeFldLabel?: string;
  postalCodeFldRule?: any;
  postalCodeFldPlaceholder?: string;
  cityFldName: any;
  cityFldLabel?: string;
  cityFldRule?: any;
  cityFldPlaceholder?: string;
  editable?: boolean;
  noTitle?: boolean;
  panelTitle?: string;
  noRegionField?: boolean;
  componentName?: string;

};

export function ECAPAddressInfo(props: addressDetailsProps): JSX.Element {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const form: FormInstance = props.form;
  const [regionCodes, setRegionCodes] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);
  const { document } = useAppSelector((state) => state.document);
  const rules  = useAppSelector((state) => state.rules);

  const getRegionDropDown = () => {
    if (regionCodes.length === 0) {
      return getRegionListData()
        .then((data) => {
          const regionList = data?.getRegionList;
          setRegionCodes(regionList);
          return regionList;
        });
    }
    return Promise.resolve(regionCodes);
  };

  const getCountryDropDown = () => {
    if (countryCodes.length === 0) {
      getCountryListData()
        .then((data) => {
          const countryList = data?.getCountryList;
          setCountryCodes(countryList);
          getRegionDropDown();
        });
    }
  };

    /**
     * These should probably be triggered from BMWCompanyHeader.tsx
     */
  useEffect(() => {
      const getRegionCodes = () => (regionCodes?.length ? Promise.resolve(regionCodes) : getRegionDropDown());
      const initRegionList = (countryCode: string) => {
          if (countryCode) {
              getRegionCodes().then((regionCodes) => {
                  const filteredRegions = regionCodes.filter((item) => item.id.countryCode === countryCode);
                  setRegionList(filteredRegions);
              });
          }
      };

      if (props.componentName === 'BMWCompanyComponent') {
          initRegionList(document.companyCountryCode);
      } else if (props.componentName === 'PartnerAddressDetails') {
          initRegionList(document.partnerAddressCountryCode);
      } else if (props.componentName === 'ShippingFromAddress') {
          initRegionList(document.shipFromCountryCode);
      } else if (props.componentName === 'ShippingToAddress') {
          initRegionList(document.shipToCountryCode);
      } else if (props.componentName === 'FiscalAddressInfo') {
          initRegionList(document.fiscalCountryCode);
      }
  }, [
      document.companyCountryCode,
      document.partnerAddressCountryCode,
      document.shipFromCountryCode,
      document.shipToCountryCode,
      document.fiscalCountryCode,
  ]);

  useEffect(() => {
    getCountryDropDown();
    if (isArray(props.countryCodeFldName))
    {
      if (props.countryCodeFldName[0] === "shippingInformation" && props.countryCodeFldName[1] === "shipFromCountryCode")
      {
        //console.log(`Get region codes for ship from country : ${document.shipFromCountryCode}`);
        const regionList = regionCodes.filter((item) => {return item.id.countryCode === document.shipFromCountryCode});
        setRegionList(regionList);
      } else if (props.countryCodeFldName[0] === "shippingInformation" && props.countryCodeFldName[1] === "shipToCountryCode")
      {
        //console.log(`Get region codes for ship to country : ${document.shipToCountryCode}`);
        const regionList = regionCodes.filter((item) => {return item.id.countryCode === document.shipToCountryCode});
        setRegionList(regionList);
      }
      else if (props.countryCodeFldName[0] === "supplierDetails" && props.countryCodeFldName[1] === "fiscalRepresentativeAddressCountryCode")
      {
        //console.log(`Get region codes for fiscal country : ${document.fiscalCountryCode}`);
        const regionList = regionCodes.filter((item) => {return item.id.countryCode === document.fiscalCountryCode});
        setRegionList(regionList);
      }
    }

  }, [regionCodes, countryCodes]);

  const OnSelectCountry = (value) =>
  {
    const selectedCountryCode = value;

    if (isArray(props.countryCodeFldName))
    {
      if (props.countryCodeFldName[0] === "shippingInformation" && props.countryCodeFldName[1] === "shipFromCountryCode")
      {
        dispatch(updateShippingFromCountryCode(selectedCountryCode));
      } else if (props.countryCodeFldName[0] === "shippingInformation" && props.countryCodeFldName[1] === "shipToCountryCode")
      {
        dispatch(updateShippingToCountryCode(selectedCountryCode));
      }
      else if (props.countryCodeFldName[0] === "supplierDetails" && props.countryCodeFldName[1] === "fiscalRepresentativeAddressCountryCode")
      {
        dispatch(updateFiscalCountryCode(selectedCountryCode));
      }
    }
    //
    //clear the region field as new country was selected
    const newValues = {};

    if (isArray(props.regionDisplayFldName)) {
        const innerObject = {};
        innerObject[props.regionDisplayFldName[1]] = undefined;

        newValues[props.regionDisplayFldName[0]] = innerObject;
    }
    else {
        newValues[props.regionDisplayFldName] = undefined;
    }

    form.setFieldsValue(newValues);
    console.log('form fields', newValues);
    //fill region list using selected country code
    const regionList = regionCodes.filter((item) => {return item.id.countryCode === selectedCountryCode});
    setRegionList(regionList);
  }

  const OnSelectRegion = (value) =>
  {
    const selectedRegionCode = value;
    //console.log(`Region Code field : ${props.regionCodeFldName} to selected ${selectedRegionCode}`);
    if (isArray(props.regionCodeFldName))
    {
      //console.log("Update region state");
      if (props.regionCodeFldName[0] === "shippingInformation" && props.regionCodeFldName[1] === "shipFromRegionCode")
      {
        //console.log(`Updating state for ${props.regionCodeFldName}`);
        dispatch(updateShippingFromRegionCode(selectedRegionCode));
      } else if (props.regionCodeFldName[0] === "shippingInformation" && props.regionCodeFldName[1] === "shipToRegionCode")
      {
        //console.log(`Updating state for ${props.regionCodeFldName}`);
        dispatch(updateShippingToRegionCode(selectedRegionCode));
      }
      else if (props.regionCodeFldName[0] === "supplierDetails" && props.regionCodeFldName[1] === "fiscalRepresentativeAddressRegionCode")
      {
        //console.log(`Updating state for ${props.regionCodeFldName}`);
        dispatch(updateFiscalRegionCode(selectedRegionCode));
      }
    }
  }

  const getOrDefaultRule = (ruleName: string, propertyCache: RuleResultCache)=> {
      if (ruleName) {
          return propertyCache.fetchRule(ruleName);
      }

      return props.editable
          ? getDefaultNotRequiredRuleset()
          : getDefaultDisabledRuleset()
    };

  return new RuleResultCache(
      rules,
      props.form,
      document,
      [
          'SHIPPED_TO_STREET',
          'SHIPPED_TO_POSTALCODE',
          'SHIPPED_TO_COUNTRYCODE',
          'SHIPPED_TO_CITYNAME',
          'ShipTo_Address_US_OR_Canada',
          'BMW_Company_Address_region',
          'ShipFrom_Address_US_OR_Canada',
      ],
      intl
  ).render((propertyCache) => {
      return (
          <Card
              bordered={true}
              size={'small'}
              title={
                  props.noTitle
                      ? ''
                      : getI18n('general-address-title', props.panelTitle ? props.panelTitle : 'Address', intl)
              }
          >
              <Row gutter={24}>
                  <Col span={10}>
                      <Form_Item
                          label={
                              props.streetFldLabel !== undefined
                                  ? props.streetFldLabel
                                  : getI18n('general-address-street-label', 'Street', intl)
                          }
                          placeholder={
                              props.streetFldPlaceholder !== undefined
                                  ? props.streetFldPlaceholder
                                  : getI18n('general-address-street-label', 'Street', intl)
                          }
                          name={props.streetFldName}
                          itemRules={getOrDefaultRule(props.streetFldRule, propertyCache)}
                      />
                      <Form_Item
                          label={
                              props.postalCodeFldLabel !== undefined
                                  ? props.postalCodeFldLabel
                                  : getI18n('general-address-postalCode-label', 'Postal Code', intl)
                          }
                          placeholder={
                              props.postalCodeFldPlaceholder !== undefined
                                  ? props.postalCodeFldPlaceholder
                                  : getI18n('general-address-postalCode-label', 'Postal Code', intl)
                          }
                          name={props.postalCodeFldName}
                          itemRules={getOrDefaultRule(props.postalCodeFldRule, propertyCache)}
                      />
                      <Form_Item
                          label={
                              props.countryFldLabel !== undefined
                                  ? props.countryFldLabel
                                  : getI18n('general-address-country-label', 'Country', intl)
                          }
                          name={props.countryDisplayFldName}
                          itemRules={getOrDefaultRule(props.countryFldRule, propertyCache)}
                      >
                          <Select
                              className=""
                              onSelect={OnSelectCountry}
                              style={{ width: 180 }}
                              showSearch={true}
                              optionFilterProp="children"
                              disabled={getOrDefaultRule(props.countryFldRule, propertyCache).readOnly}
                              placeholder={getI18n('general-country-codes-placeholder', 'Country Codes', intl)}
                              allowClear={true}
                          >
                              {countryCodes &&
                                  countryCodes.map((item) => (
                                      <Option
                                          key={`${item.id}_${item.countryCode}`}
                                          value={item.id}
                                          data-testid={item.country}
                                      >
                                          {getI18n(item.phraseId, item.country, intl)}
                                      </Option>
                                  ))}
                          </Select>
                      </Form_Item>
                  </Col>

                  <Col span={10}>
                      <Form_Item
                          label={
                              props.cityFldLabel !== undefined
                                  ? props.cityFldLabel
                                  : getI18n('general-address-city-label', 'City', intl)
                          }
                          placeholder={
                              props.cityFldPlaceholder !== undefined
                                  ? props.cityFldPlaceholder
                                  : getI18n('general-address-city-label', 'City', intl)
                          }
                          name={props.cityFldName}
                          itemRules={getOrDefaultRule(props.cityFldRule, propertyCache)}
                      />
                      {props.noRegionField === undefined || props.noRegionField === false ? (
                          <Form_Item
                              label={
                                  props.regionCodeFldLabel !== undefined
                                      ? props.regionCodeFldLabel
                                      : getI18n('general-address-region-label', 'Region', intl)
                              }
                              name={props.regionDisplayFldName}
                              itemRules={getOrDefaultRule(props.regionCodeFldRule, propertyCache)}
                          >
                              <Select
                                  className=""
                                  style={{ width: 180 }}
                                  showSearch={true}
                                  optionFilterProp="children"
                                  onSelect={OnSelectRegion}
                                  disabled={getOrDefaultRule(props.regionCodeFldRule, propertyCache).readOnly}
                                  placeholder={getI18n('ecap-general-region-codes-placeholder', 'Region Codes', intl)}
                                  allowClear={true}
                              >
                                  {regionList &&
                                      regionList.map((item) => (
                                          <Option
                                              key={`${item.id.regionCode}_${item.region}`}
                                              value={item.id.regionCode}
                                              data-testid={item.region}
                                          >
                                              {item.region}
                                          </Option>
                                      ))}
                              </Select>
                          </Form_Item>
                      ) : null}
                  </Col>
              </Row>
          </Card>
      );
  });
}